module.exports = __webpack_public_path__ + "img/infratel-flyer.ae2dac7f.jpg";